
import { Vue, Component, Prop } from "vue-property-decorator";
import UiButtonMessage from "@/components/button/ui-button-message.vue";

@Component({
  components: {
    UiButtonMessage,
  },
})
export default class FiltersContainer extends Vue {
  @Prop({ default: "Filters", type: String }) readonly title!: string;
}
